<template>
  <v-container class="login">
    <v-row justify="center">
      <v-col cols="12" md="5">
        <!-- Header section -->
        <div class="login__header">
          <h3 class="login__title">¡Hola! Te estábamos esperando</h3>
          <p class="login__subtitle">
            Ingresa para seguir conectando personas y organizaciones desde el propósito.
          </p>
        </div>

        <!-- Social login -->
        <div class="login__section">
          <!-- <v-btn
            class="mb-4 white--text"
            color="#0177B5"
            :loading="loading"
            :disabled="loading"
            @click="authenticate('linkedin')"
            elevation="2"
            x-large
            rounded
            block
          >
            <v-img :src="require('@/assets/images/linkedin.svg')" width="1" />
            <v-spacer />
            Ingresa con LinkedIn
            <v-spacer />
          </v-btn> -->

          <v-btn
            class="mb-4"
            color="#FFFFFF"
            :loading="loading"
            :disabled="loading"
            @click="authenticate('google')"
            elevation="2"
            x-large
            rounded
            block
          >
            <v-img :src="require('@/assets/images/google.svg')" width="1" />
            <v-spacer />
            Ingresa con Google
            <v-spacer />
          </v-btn>
        </div>

        <!-- Email login form -->
        <div class="login__section">
          <p class="login__text">O ingresa con</p>
          <v-form class="login__form">
            <v-text-field
              v-model="email"
              class=""
              data-test="email"
              name="email"
              label="Email"
              placeholder="Ingresa tu mail"
              hint="Obligatorio"
              required
              outlined
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            />
            <v-text-field
              v-model="password"
              class=""
              data-test="password"
              name="password"
              label="Contraseña"
              placeholder="Ingresa tu Contraseña"
              hint="Obligatorio"
              required
              outlined
              :error-messages="passwordErrors"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
            />

            <v-btn
              class="btn-main-job"
              data-test="loginBtn"
              color="info"
              :loading="loading"
              :disabled="$v.$invalid || loading"
              @click="login"
              elevation="0"
              button
              large
              block
            >
              INGRESAR
            </v-btn>
          </v-form>
          <div class="text-center">
            <p id="input-error" class="error mt-5" v-if="remoteError">{{ remoteError }}</p>
          </div>
        </div>  

        <!-- Not registered? -->
        <div class="login__section">
          <p class="login__text">¿No estás registrado/a?</p>
          <v-btn
            class="white--text"
            to="/register"
            elevation="0"
            color="#3BADFF"
            large
            block
          >
            REGÍSTRATE AQUÍ
          </v-btn>
        </div>
      </v-col>

      <!-- Recover pass -->
      <v-col cols="12">
        <p class="login__text">
          Si olvidaste tu contraseña, 
          <router-link to="/password/forget" class="btn-forget">
            haz click aquí
          </router-link>
        </p>
        <p class="login__text">
          Si tienes problemas escríbenos directamente a 
          <a href="mailto:hola@trabajoconsentido.com" class="btn-forget">
            hola@trabajoconsentido.com
          </a>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import NProgress from "nprogress";
import { meta } from "@/libs/mixins";

export default {
    name: "Login",

    props: ["target"],
    
    mixins: [validationMixin, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Iniciar sesión",
        });
    }, 

    data() {
        return {
            email: "",
            password: "",
            showPassword: false,
            errors: [],
            loading: false,
        };
    },

    computed: {
        remoteError() {
            let err = "";
            if (this.errors.length > 0)
                err = this.errors[this.errors.length - 1];
            return err;
        },
        emailErrors() {
            const errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.email && errors.push("Se debe ingresar e-mail valido");
            !this.$v.email.required && errors.push("E-mail es requerido");
            return errors;
        },
        passwordErrors() {
            const errors = [];
            if (!this.$v.password.$dirty) return errors;
            !this.$v.password.required && errors.push("Password es requerido");
            return errors;
        },
    },
    
    methods: {
        login() {
            this.loading = true;
            NProgress.start();
            this.$store.dispatch("users/login", {
                target: this.target,
                email: this.email,
                password: this.password,
                type: "normal"
            }).then(() => {

                this.$store.dispatch("cookies/activity", {
                    path: this.$route.path,
                    activity: "taskComplete"
                });

                setCookie("nps_email", this.email, 3600);
                this.$router.push({ name: "RedirectionRule" });
                NProgress.done();
                
            }).catch(err => {
              
                this.$store.dispatch("cookies/activity", {
                    path: this.$route.path,
                    activity: "taskError",
                    args: JSON.stringify(err)
                });

                this.loading = false;
                this.errors = err;
                NProgress.done();
            });
        },
        authenticate(provider) {
            this.loading = true;
            this.$auth.link(provider, {
                provider
            }).then((data) => {
                let profile = data.content.profile;
                this.email = profile.email;
                this.password = profile.id;
                this.$store.dispatch("users/login", {
                    email: this.email,
                    password: this.password,
                    type: "social"
                }).then(() => {
                    setCookie("nps_email", this.email, 3600);
                    this.$router.push({ name: "RedirectionRule" });
                }).catch(err => {
                    this.loading = false;
                    this.errors = err;
                });
            }).catch(err => {
                this.loading = false;
                console.error(err);
            });
        },
        onSuccess(googleUser) {
            // console.log(googleUser);

            // This only gets the user information: id, name, imageUrl and email
            // console.log(googleUser.getBasicProfile());
        },
        onFailure(googleUser) {
            // console.log(googleUser);

            // This only gets the user information: id, name, imageUrl and email
            // console.log(googleUser.getBasicProfile());
        }
    },
        
    validations: {
        email: { required, email },
        password: { required, minLength: minLength(6) },
    },
};
</script>
